import { createGlobalStyle } from 'styled-components';
import { reset } from 'styled-reset';
import 'react-datepicker/dist/react-datepicker.css';
import '../../App.css';

const GlobalStyle = createGlobalStyle`
${reset},

html {
  box-sizing: border-box;
  font-size: 1rem;
}
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family:  pretendard, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f7f7f7;
}

@media (max-width: 1369px) {
  body {
    width: fit-content;
  }
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

a {
  color : black;
  text-decoration: none;
}
`;
export default GlobalStyle;
